import React, { useState } from "react";
import {
	IonCol,
	IonImg,
	IonLabel,
	IonRow,
	IonSlide,
	IonSlides,
	isPlatform,
} from "@ionic/react";
import * as constants from "../../../constants";
import { connect } from "react-redux";
import "../Workshop/selectWorkshop.scss";
import { getListOfWorkshops } from "../../../Store/Actions";
// import { GoogleApiKey } from "../../../utils/maps";

const SelectWorkShop: React.FC = (props: any) => {
	const [listOfWorkshops, setListOfWorkShops] = useState<any>([]);

	React.useEffect(() => {
		// console.log("listOfWorkshops ......", listOfWorkshops);
		setListOfWorkShops([...props.listOfWorkshops]);
	}, [props.listOfWorkshops]);

	React.useEffect(() => {
		const addressDetails = (props.userAddressList || []).find(
			(ele: any) => ele.did === props.selectedAddressRef
		);

		// if (!!props.history) {
		// 	if (!!props.history.location) {
		// 		if (!!props.history.location.state) {
		// 			if (!!props.history.location.state.serviceProviderWorkshopList) {
		// 				if (props.history.location.state.serviceProviderWorkshopList.length === 0) {
		// if (
		// 	!!props.history.location.state.serviceProviderWorkshopList &&
		// 	props.history.location.state.serviceProviderWorkshopList.length === 0
		// ) {
		// 	!!addressDetails && Object.keys(addressDetails).length
		// 		? props.getListOfWorkshops({
		// 				latitude: addressDetails.latitude,
		// 				longitude: addressDetails.longitude,
		// 				profileLocationName: addressDetails.addressType,
		// 				radius: 600,
		// 		  })
		// 		: props.getListOfWorkshops({
		// 				latitude: props.curLat,
		// 				longitude: props.curLong,
		// 				profileLocationName: "current",
		// 				radius: 600,
		// 		  });
		// }
		//        }
		// 			}
		// 		}
		// 	}
		// }

		// console.log("Select Workshop props ......", props);
		if (
			!!props.history.location.state.serviceProviderWorkshopList &&
			props.history.location.state.serviceProviderWorkshopList.length > 0
		) {
			setListOfWorkShops([...props.history.location.state.serviceProviderWorkshopList]);
		} else {
			!!addressDetails && Object.keys(addressDetails).length
				? props.getListOfWorkshops({
						latitude: addressDetails.latitude,
						longitude: addressDetails.longitude,
						profileLocationName: addressDetails.addressType,
						radius: 600,
						clientName: constants.CLIENT_NAME
				  })
				: props.getListOfWorkshops({
						latitude: props.curLat,
						longitude: props.curLong,
						profileLocationName: "current",
						radius: 600,
						clientName: constants.CLIENT_NAME
				  });
		}
	}, [props.userAddressList, props.selectedAddressRef]);

	return (
		<>
			<IonCol className="middle_panle res_bg_color" size-md="6">
				<div
					className="personal_details_div workshowQua_header_floating"
					style={{
						paddingTop: isPlatform("android") ? 20 : 0,
					}}
				>
					<div className="personal_details_div_child paddingLeft25 wholeApp">
						<IonImg
							src="/images/back_arrow.svg"
							className="back_arrow"
							onClick={() => props.history.goBack()}
						/>
						<IonLabel className="personal_details_labels" color="secondary">
							{constants.SELECT_WORKSHOP}
						</IonLabel>
						<div />
					</div>
				</div>
				<div className="sw_container ">
					{!!listOfWorkshops.length &&
						listOfWorkshops
							.filter((ele: any) => ele.recommended)
							.map((ele: any, index: any) => (
								<div key={index}>
									<div className="workshop_card_rec">
										{/* <IonSlides pager={ele.imageUrls.length > 2 ? true : false}>
                      {!!ele.imageUrls.length &&
                        ele.imageUrls.map((image: any) => (
                          <IonSlide>
                            <img src={image} alt="" className="large_img" />
                          </IonSlide>
                        ))}
                    </IonSlides> */}
										{!!ele.imageUrls.length && (
											<div
												style={{
													position: "relative",
												}}
											>
												<div
													style={{
														position: "absolute",
														right: 14,
														backgroundColor: "#38c172",
														color: "#ffffff",
														fontSize: 8,
														padding: 4,
														borderRadius: "0px 0px 5px 5px",
													}}
												>
													<IonLabel>Recommended</IonLabel>
												</div>
												<img src={ele.imageUrls[0]} alt="" className="large_img" />
											</div>
										)}
										<IonRow className="bc_text_container">
											<div className="name_container">
												<IonLabel
													className="bc_workshop_display_name"
													onClick={() => {
														props.history.push({
															pathname: `/portal/workshop-detail/${ele.workshopId}`,
															state: {
																workshopDetail: ele,
																...props.location.state,
															},
														});
													}}
												>
													{ele.displayTitle}
												</IonLabel>
												<IonLabel className="bc_workshop_desc">
													{ele.shortDescription}
												</IonLabel>
											</div>
											<div className="ws_rating_desc">{ele.quality}</div>
										</IonRow>
										<IonRow className="details_div">
											<div className="pill_style loc_pill"> {ele.address}</div>
											<div className="pill_style distance_pill">
												{!!ele.distance
													? ele.distance + " " + ele.duration
													: " 1 km Away"}
											</div>
											<div className="pill_style rating_pill row">
												<img src="/images/ws_star.svg" className="ws_star" />
												<div className="rating_text">{ele.rating}</div>
											</div>
										</IonRow>
										<div className=" dashed_line"></div>
										<IonRow className="discount_container">
											<img src="/images/save_per.svg" className="save_img" />
											<IonLabel className="discount_text">{ele.promotionalText}</IonLabel>
										</IonRow>
									</div>
								</div>
							))}

					{/** small Card  *****/}
					{!!listOfWorkshops.length &&
						listOfWorkshops
							.filter((ele: any) => !ele.recommended)
							.map((ele: any, index: any) => (
								<div
									key={index}
									className="sw_card_small"
									onClick={() => {
										props.history.push({
											pathname: `/portal/workshop-detail/${ele.workshopId}`,
											state: {
												workshopDetail: ele,
												...props.location.state,
											},
										});
									}}
								>
									<div className="row_container">
										{!!ele && ele.imageUrls.length ? (
											<img src={ele.imageUrls[0]} className="sw_small_img" />
										) : (
											<img
												src="/images/select_workshop_small.svg"
												className="sw_small_img"
											/>
										)}
										<div className="sw_small_text_container">
											<IonLabel className="bc_workshop_display_name sw_display_name">
												{ele.displayTitle}
											</IonLabel>
											<IonLabel className="bc_workshop_desc sw_display_name">
												{ele.shortDescription}
											</IonLabel>
											<IonCol style={{ paddingLeft: 0 }}>
												{/* {(cordova.platformId === "android" || cordova.platformId === "ios") === */}
												{!!window.cordova === true ? (
													<div className="pill_style sw_small_loc_pill_mobile">
														{" "}
														{ele.address}
													</div>
												) : (
													<div className="pill_style sw_small_loc_pill">
														{" "}
														{ele.address}
													</div>
												)}
												{/* <div className="pill_style sw_small_loc_pill"> {ele.address}</div> */}

												<IonRow>
													<div className="pill_style distance_pill row">
														{/* {" "} */}
														<img src="/images/pointer.svg" className="distance_pointer" />
														<div className="distance_text">
															{!!ele.distance
																? ele.distance + " " + ele.duration
																: " 1 km Away"}
														</div>
													</div>
													<div className="pill_style rating_pill row">
														<img src="/images/ws_star.svg" className="ws_star" />
														<div className="rating_text">
															{!!ele.rating ? ele.rating : "4.5"}
														</div>
													</div>
													{/* <div className="ws_rating_desc">
                            {!!ele.quality ? ele.quality : "Gold"}
                          </div> */}
												</IonRow>
											</IonCol>
										</div>
									</div>
									<div className="small_dashed_line"></div>
									<IonRow>
										<img src="/images/save_per.svg" className="save_img" />
										<IonLabel className="discount_text">
											* Indicative Price
											{/* Save upto 30% on your service when you book with Us */}
										</IonLabel>
									</IonRow>
								</div>
							))}
				</div>
			</IonCol>
		</>
	);
};

export default connect(({ userInfo, workshop }: any) => ({ ...userInfo, ...workshop }), {
	getListOfWorkshops,
})(SelectWorkShop);
